import * as THREE from "three";
import gsap from "gsap";

const parameters = {
  materialColor: "grey",
};

/**
 * Base
 */
// Canvas
const canvas = document.querySelector("canvas.webgl");

// Scene
const scene = new THREE.Scene();

/**
 * Lights
 */
const firstLight = new THREE.PointLight("white", 150);
const secondLight = new THREE.DirectionalLight("gold", 10);

/**
 * Objects
 */
// Texture
const textureLoader = new THREE.TextureLoader();
const relaxnSpaceTexture = textureLoader.load("textures/nyameDua.jpg");
const pachamamaTexture = textureLoader.load("textures/water.jpg");
const gradientTexture = textureLoader.load("textures/gradients/3.jpg");
const particleTexture = textureLoader.load("/textures/particles/8.png");

gradientTexture.magFilter = THREE.NearestFilter;

// Materials
// Mesh toon only appears with light
const material = new THREE.MeshToonMaterial({
  color: parameters.materialColor,
  gradientMap: gradientTexture,
});
const pachamamaMaterial = new THREE.MeshPhysicalMaterial({
  map: pachamamaTexture,
  iridescence: 6,
  iridescenceIOR: 1,
  iridescenceThicknessRange: [100, 800],
  metalness: 0.8,
  roughness: 0.1,
  reflectivity: 1,
});
const octahedronMaterial = new THREE.MeshBasicMaterial({
  wireframe: true,
  color: "purple",
});
const relaxMaterial = new THREE.MeshPhysicalMaterial({
  map: relaxnSpaceTexture,
  iridescence: 6,
  iridescenceIOR: 1,
  iridescenceThicknessRange: [100, 800],
  metalness: 0.7,
  roughness: 0,
  transmission: 0.5,
  ior: 1.5,
  thickness: 0.1,
});

// Meshes
const objectDistance = 4;

// const mesh1 = new THREE.Mesh(new THREE.TorusGeometry(1, 0.4, 16, 60), material);
const mesh1 = new THREE.Mesh(
  new THREE.SphereGeometry(1, 96, 96),
  relaxMaterial
);
const mesh2 = new THREE.Mesh(
  new THREE.OctahedronGeometry(1.25),
  octahedronMaterial
);
const mesh3 = new THREE.Mesh(
  new THREE.TorusKnotGeometry(0.7, 0.25, 100, 16),
  material
);

const mamaEgg = mesh1.clone(true);
mamaEgg.material = pachamamaMaterial;
mamaEgg.rotation.y = -Math.PI * 0.5;
mamaEgg.scale.set(0.25, 0.5, 0.25);
mamaEgg.position.y = -objectDistance * 1;

mesh1.scale.set(0.5, 1, 0.5);

firstLight.position.y = -objectDistance * 0 - 1.5;
secondLight.position.y = -objectDistance * 1;

mesh1.position.y = -objectDistance * 0;
mesh2.position.y = -objectDistance * 1;
mesh3.position.y = -objectDistance * 2;

firstLight.position.x = 2;
secondLight.position.x = -2;
mamaEgg.position.x = -2;
mesh1.position.x = 2;
mesh2.position.x = -2;
mesh3.position.x = 2;

scene.add(mesh1, mesh2, mesh3, mamaEgg, firstLight, secondLight);
const sectionMeshes = [mesh1, mesh2, mesh3, mamaEgg];

// /**
//  * Particles
//  */
//Geometry
const particlesCount = 500;
const positions = new Float32Array(particlesCount * 3); //need 3 values per particle position -x,y,z

for (let i = 0; i < particlesCount; i++) {
  positions[i * 3 + 0] = (Math.random() - 0.5) * 10; //x-position (*3 so it does it every 3 steps)
  positions[i * 3 + 1] =
    objectDistance * 0.5 -
    Math.random() * (objectDistance * sectionMeshes.length); //y-position
  positions[i * 3 + 2] = (Math.random() - 0.5) * 10; //z-position
}

const particlesGeometry = new THREE.BufferGeometry();
particlesGeometry.setAttribute(
  "position",
  new THREE.BufferAttribute(positions, 3)
);
//we set the attribute of the particlesGeometry we created
//first parameter is the name - 'position', 2nd is the bufferAttribute itself
//and within the buffer attribute  1st parameter is the positions array,
//2nd parameter is the number of values per vertex (3)

// Material
const particlesMaterial = new THREE.PointsMaterial({
  sizeAttenuation: true,
  size: 0.2,
  transparent: true,
  alphaMap: particleTexture,
  // solving particle issues/bugs
  depthWrite: false,
  blending: THREE.AdditiveBlending,
  vertexColors: true,
});

// Points -  equivalent to particle Mesh
const particles = new THREE.Points(particlesGeometry, particlesMaterial);
scene.add(particles);

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight("#ffffff", 3);
directionalLight.position.set(1, 1, 0);
scene.add(directionalLight);
/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

/**
 * Camera
 */

//Group
const cameraGroup = new THREE.Group();
scene.add(cameraGroup);
// Base camera
const camera = new THREE.PerspectiveCamera(
  35,
  sizes.width / sizes.height,
  0.1,
  100
);
camera.position.z = 6;
cameraGroup.add(camera);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true, //make background transparent
});
// renderer.setClearAlpha(0) //sets background transparency
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Scroll
 */
let scrollY = window.scrollY; //contains amt of lixels that have been scrolled
let currentSection = 0;

window.addEventListener("scroll", () => {
  scrollY = window.scrollY;
  // console.log(scrollY + 'user is scrolling')
  const newSection = Math.round(scrollY / sizes.height);
  if (newSection != currentSection) {
    currentSection = newSection;
    gsap.to(sectionMeshes[currentSection].rotation, {
      duration: 1.5,
      ease: "power2.inOut",
      x: "+=6",
      y: "+=3",
      z: "+=1.5",
    });
  }
});

/**
 * Cursor
 */
const cursor = {};
cursor.x = 0;
cursor.y = 0;

//going right is positive, going down is positive
window.addEventListener("mousemove", (event) => {
  // cursor.x = event.clientX
  // cursor.y = event.clientY
  //we have to adapt these values to our specific scene
  cursor.x = event.clientX / sizes.width - 0.5;
  cursor.y = event.clientY / sizes.height - 0.5;
});

/**
 * Animate
 */
const clock = new THREE.Clock();
let previousTime = 0;

const tick = () => {
  const elapsedTime = clock.getElapsedTime();
  const deltaTime = elapsedTime - previousTime;
  previousTime = elapsedTime;

  //Animate camera
  //scrollY pixels divided by window width x object Distance
  camera.position.y = (-scrollY / sizes.height) * objectDistance; // we want camera to go down in opposite of scroll value

  const parallaxX = cursor.x * 0.5;
  const parallaxY = -cursor.y * 0.5; //cos y pixel values increase going down the screen so negate it to mouse movements
  cameraGroup.position.x +=
    (parallaxX - cameraGroup.position.x) * 5 * deltaTime;
  cameraGroup.position.y +=
    (parallaxY - cameraGroup.position.y) * 5 * deltaTime;

  //We'll have to adjust this for high frequency screens where the animate function
  //runs more frequently
  // we need to know how much time is spent between consecutive frames (deltaTime)
  // because of the deltaTime we can change the multiplier from *0.1 to *5
  // but it will adjust for different screen frequencies

  //so the y position movements of the scroll and mousemovements don't clash,
  //we will put the camera in a group and move the cameraGroup instead
  // We need to make the camera move not as fast, with some easing, smoothing or lerpingb
  //Animate meshes
  for (const mesh of sectionMeshes) {
    // mesh.rotation.x = elapsedTime * 0.1;
    // mesh.rotation.y = elapsedTime * 0.12;
    mesh.rotation.x += deltaTime * 0.1;
    mesh.rotation.y += deltaTime * 0.12;
  }

  // Render
  renderer.render(scene, camera);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
